export default __webpack_public_path__ + "33911a8731f6fe3a1fb3bf463e68ea93.png";